import React, {useEffect, useMemo, useRef, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import Sidebar from "../../../components/SideBar";
import Navbar from "../../../components/NavBar";
import {getStaffId} from "../../../../axios/CurrentMedicalStaffManager";
import {getPendingDoctorRequests} from "../../../../service-layer/MedicalStaffService";
import ManageRequest from "../Components/ManageRequest/ManageRequest";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ClipLoader from "react-spinners/ClipLoader";
import {format} from "date-fns";
import LogoutModal from "../../../components/logout-moal/LogoutModal";

export const PendingRequestsTable = () => {
  const { t } = useTranslation();

  const [DoctorData, setDoctorData] = useState([
    {
      medicalStaffRequestId: -1,
      name: "",
      surname: "",
      fiscalCode: "",
      email: "",
      specialization: "",
      registrationNumber: "",
      timestamp: "",
    },
  ]);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const [colDefs, setColDefs] = useState([
    { field: "surname", headerName: t("surname") },
    { field: "name", headerName: t("name") },
    { field: "fiscalCode", headerName: t("fiscalCode") },
    { field: "email", headerName: t("email") },
    { field: "specialization", headerName: t("specialization") },
    { field: "registrationNumber", headerName: t("registrationNumber") },
    {
      field: "timestamp",
      headerName: t("timestamp"),
      valueFormatter: (params) =>
        format(new Date(params.value), "dd/MM/yyyy HH:mm"),
    },
    {
      field: "ManageRequest",
      headerName: t("manageRequest"),
      cellRenderer: ManageRequest,
      cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
      },
    },
  ]);

  const gridRef = useRef(null);

  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      gridRef.current.api.sizeColumnsToFit();
    }
  }, [gridRef]);

  const navigate = useNavigate();
  useEffect(() => {
    if (window.localStorage.getItem("auth_token") === null) navigate("/login");
  }, [navigate]);

  useEffect(() => {
    const col = [
      {
        field: "surname",
        headerName: t("surname"),
        filter: true,
        floatingFilter: true,
      },

      {
        field: "name",
        headerName: t("name"),
        filter: true,
        floatingFilter: true,
      },

      {
        field: "fiscalCode",
        headerName: t("fiscalCode"),
        filter: true,
        floatingFilter: true,
      },
      {
        field: "email",
        headerName: t("email"),
        filter: true,
        floatingFilter: true,
      },

      {
        field: "specialization",
        headerName: t("specialization"),
        filter: true,
        floatingFilter: true,
      },

      {
        field: "registrationNumber",
        headerName: t("registrationNumber"),
        filter: true,
        floatingFilter: true,
      },

      {
        field: "timestamp",
        headerName: t("timestamp"),
        valueFormatter: (params) => {
          const romeTimeFormatter = new Intl.DateTimeFormat(t('volte') === 'volte' ? "it-IT" : "en-GB", {
            timeZone: "Europe/Rome",
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: t('volte') !== 'volte'
          });

          const offset = new Date().getTimezoneOffset()*60000;
          const romeTime = new Date(new Date(params.value).getTime() - offset);

           return romeTimeFormatter.format(new Date(romeTime))
         

        }
          ,
      },
      {
        field: "ManageRequest",
        headerName: t("manageRequest"),
        cellRenderer: (params) => (
          <div style={{ marginTop: "0px" }}>
            <ManageRequest
              requestId={params.data.medicalStaffRequestId}
              requestData={params.data}
            />
          </div>
        ),
      },
    ];

    setColDefs(col);
  }, [t]);

  const onFirstDataRendered = (params) => {
    params.api.sizeColumnsToFit();
  };

  useEffect(() => {
    getPendingDoctorRequests(getStaffId()).then((response) => {
      console.log("All Doctors pending requests:");
      console.log(response.data);

      // sort the list in descending order with respect to the timestamp
      const sortedData = response.data.sort((a, b) => {
        return new Date(b.timestamp) - new Date(a.timestamp);
      });
      setDoctorData(sortedData);
      setLoading(false);
    }).catch(() => {
      setShowLogoutModal(true);
    });
  }, []);

  const defaultColDef = useMemo(() => {
    return {
      flex: 1,
      minWidth: 100,
    };
  }, []);

  const pagination = true;
  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10];
  const token = window.localStorage.getItem("auth_token");
  const handleConfirm = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("name");
    localStorage.removeItem("surname");
    localStorage.removeItem("authority");
    setShowLogoutModal(false);
    navigate("/");
  };

  return (
    <>
      {token && (
        <div className="dashboard d-flex">
          <div>
            <Sidebar />
          </div>
          <div
            style={{
              flex: "1 1 auto",
              display: "flex",
              flexFlow: "column",
              height: "100vh",
              overflowY: "hidden",
            }}
          >
            <Navbar />
            <div style={{ height: "100%" }}>
              {DoctorData.length > 0 ? (
                <div className="ag-theme-alpine" style={{ padding: "20px" }}>
                  {!loading && (
                    <AgGridReact
                      ref={gridRef}
                      rowData={DoctorData}
                      columnDefs={colDefs}
                      defaultColDef={defaultColDef}
                      onFirstDataRendered={onFirstDataRendered}
                      domLayout="autoHeight"
                      pagination={pagination}
                      paginationPageSize={paginationPageSize}
                      paginationPageSizeSelector={paginationPageSizeSelector}
                    />
                  )}

                  {loading && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "10px",
                        backgroundColor: "white",
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <ClipLoader
                        color="#204770"
                        loading={loading}
                        // cssOverride={override}
                        size={100}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <h3>{t("noRequestsFound")}</h3>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {!token && <div className="login-container"></div>}
      <LogoutModal
          show={showLogoutModal}
          handleConfirm={handleConfirm}
          handleClose={handleConfirm}
          title={t("login")}
          message={t("session_expired_please_login_again")}
          tag={"Login"}
      />
    </>
  );
};

PendingRequestsTable.propTypes = {};
